import { render, staticRenderFns } from "./PromotionsModule.vue?vue&type=template&id=dc3de15c"
import script from "./PromotionsModule.vue?vue&type=script&lang=js"
export * from "./PromotionsModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports